import { Component, Input, OnInit } from '@angular/core';
import { Share } from '@capacitor/share';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-share-per-carrots',
  templateUrl: './profile-share-per-carrots.component.html',
  styleUrls: ['./profile-share-per-carrots.component.scss'],
})
export class ProfileSharePerCarrotsComponent  implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData: any;
  @Input() srcIconCoin: string = '';
  /** Base URL for share link (e.g. https://app.veggly.net or https://app.fyradating.com). Defaults to Veggly. */
  private shareBaseUrl = 'https://app.veggly.net';

  constructor(private modalController: ModalController,
    private translate: TranslateService,
    private navParams: NavParams,
  ) { }

  ngOnInit() {
    this.userData = this.navParams.get('userId');
    this.shareBaseUrl = this.navParams.get('shareBaseUrl') ?? this.shareBaseUrl;
  }

  // Fechar modal
  goBack() {
    this.modalController.dismiss();
  }

  profileSharePerCarrots() {
    const base = this.shareBaseUrl.replace(/\?$/, '').replace(/\/*$/, '');
    const sep = base.includes('?') ? '&' : '?';
    const shareUrl = base + sep + 'referralUserId=' + this.userData?._id.$oid;
    Share.share({
      text: this.translate.instant('checkVegglyMsg') + shareUrl,
      title: this.translate.instant('checkVegglyTitle')
    }).then((sucess) => {
      console.log('share succesfull: ' + JSON.stringify(sucess));
    }).catch((error) => {
      console.log('share unsuccesfull: ' + JSON.stringify(error));
    });
  }

}
